import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { getApi } from './index';
import { isStudentApp } from '../util/app-util';
import { hasAuthCookies } from '../util/auth-cookie-util';

const educatorAppAuthStrategy = hasAuthCookies()
  ? AuthStrategy.AUTH_TOKEN
  : AuthStrategy.HTTP_AUTHENTICATION;

const createEvent = async (type: string, data: any) => {};
// getApi(isStudentApp ? AuthStrategy.SESSION : educatorAppAuthStrategy)
//   .onError(() => null)
//   .createTelemetryEvent({
//     url: '/events',
//     payload: { type, data },
//   });

const createLog = async (type: string, data: any) => {
  // getApi(isStudentApp ? AuthStrategy.SESSION : educatorAppAuthStrategy)
  //   .onError(() => null)
  //   .createTelemetryEvent({
  //     url: '/logs',
  //     payload: { type, data },
  //   });
};

export { createEvent, createLog };
